import type { ChangeEventHandler, ComponentProps, FC } from 'react'
import Icon from './Icon'

interface SearchBarProps extends ComponentProps<'input'> {
  label: string
  onSearch: (value: string) => void
}

const SearchBar: FC<SearchBarProps> = ({
  label,
  onSearch: parentOnSearch,
  className = '',
  onChange: parentOnChange = () => null,
  ...props
}) => {
  const classes = [
    'block w-full bg-zinc-800 py-3 pl-0 pr-4 text-sm placeholder:text-sm placeholder:font-semibold placeholder:text-gray-300 focus:outline-none',
    className,
  ]
  const onChange: ChangeEventHandler<HTMLInputElement> = (evt) => {
    parentOnChange(evt)
    parentOnSearch(evt.currentTarget.value)
  }
  return (
    <>
      <div className="pointer-events-none flex items-center pl-4">
        <Icon name="search" fill="#9ca3af" width={20} height={20} />
      </div>
      <input
        type="text"
        className={classes.join(' ')}
        placeholder={label}
        onChange={onChange}
        {...props}
      />
    </>
  )
}

export default SearchBar
